import { SliderMarks } from "antd/lib/slider";
import React, { useMemo } from "react";
import { CustomerOrderProductInfo } from "../../../../../../model/OrderManagement/CustomerOrder";
import { dateFormat } from "../../../../../../shared/utils/Dates/format";
import color from "../../../../../../theme/color";
import { getValueEnum } from "../../../../Unbookable/utils";
import { OrderStatusType } from "../../../Tags/OrderStatus";
import { NumRepairOrderStatus } from "../../../utils/RepairOrder";
import { repairMarkerForm } from "../../../utils/markers/Repair";
import { ProcessStepLabel } from "./Label";
import { SliderSteps } from "./index.styled";

interface RepairProductItemTireProcessFormProps {
  dataSource?: CustomerOrderProductInfo;
  canceledAt?: string; // 예약취소일때,
}

/**
 * 주문 및 반품 진행상황 - 타이어 & 엔진오일
 * @param param0
 * @returns
 */
export const RepairProductItemTireProcessForm: React.FC<
  RepairProductItemTireProcessFormProps
> = ({ dataSource, canceledAt }) => {
  /**
   * 반응형 날짜포맷
   */
  const format = "YY.MM.DD";

  const timeFormat = "HH:mm";
  /**
   * 진척도
   */
  const processValues = useMemo(() => {
    return getValueEnum(
      dataSource?.orderItemStatus as OrderStatusType,
      NumRepairOrderStatus
    );
  }, [dataSource]);

  /**
   * 진행도 라벨
   */
  const marks = useMemo(() => {
    const mark = repairMarkerForm.reduce((a, b, idx, arr) => {
      const data = { ...dataSource } as { [k: string]: any };
      const date = data[b.date];

      // 세차권은 만료예정일 표출
      if (a && !a[b.key]) {
        a[b.key] = {
          label: (
            <ProcessStepLabel
              title={b.title}
              {...(date &&
                !canceledAt && {
                  description: `${dateFormat(date, format)}\n${dateFormat(
                    date,
                    timeFormat
                  )}`,
                })}
              color={
                date &&
                !canceledAt &&
                +b.key <= +(processValues || 1) &&
                color.primary3
              }
            />
          ),
          ...(idx === arr.length - 1 && {
            style: {
              right: "-50%",
            },
          }),
        };
      }

      return a;
    }, {} as SliderMarks);

    if (mark && !!canceledAt) {
      mark[1] = (
        <ProcessStepLabel
          title="예약취소"
          description={
            canceledAt &&
            `${dateFormat(canceledAt, format)}\n${dateFormat(
              canceledAt,
              timeFormat
            )}`
          }
          color={color.red3}
        />
      );
    }

    return mark;
  }, [format, canceledAt, dataSource]);

  return (
    <>
      <SliderSteps
        className={dataSource && `step ${dataSource?.orderItemNo}`}
        marks={marks}
        min={0}
        max={12}
        value={
          canceledAt
            ? 1
            : +((dataSource?.orderItemStatus && processValues) || 1)
        }
        error={!!canceledAt}
      />
    </>
  );
};
